import React from 'react';
import { ThankYouContainer } from '../../atoms/thank-you-container/thank-you-container.atom';
import { Text } from '../../atoms/text/text.atom';

interface OrderDetailProps {
  label: string;
  value: string;
}


export const OrderDetail: React.FC<OrderDetailProps> = ({ label, value }) => {
  return (
    <ThankYouContainer
      padding="0.75rem 0"
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        borderBottom: '1px solid #f3f4f6',
      }}
    >
      <Text color="#6b7280" weight="500">
        {label}
      </Text>
      <Text weight="600">{value}</Text>
    </ThankYouContainer>
  );
};